/**
 * Utility functions for chart customizations
 */

/**
 * Formats long category labels to display in multiple lines
 * @param {string} value - The label text
 * @param {number} maxLength - Maximum characters per line (default: 15)
 * @returns {string|Array} - Original value if short, array of lines if long
 */
export const formatMultilineLabel = (value, maxLength = 15) => {
  if (typeof value !== 'string' || value.length <= maxLength) {
    return value;
  }
  
  const words = value.split(' ');
  const lines = [];
  let currentLine = '';
  
  words.forEach(word => {
    if (currentLine.length + word.length + 1 <= maxLength) {
      currentLine += (currentLine ? ' ' : '') + word;
    } else {
      if (currentLine) lines.push(currentLine);
      currentLine = word;
    }
  });
  
  if (currentLine) lines.push(currentLine);
  return lines;
};

/**
 * Creates xaxis configuration with multi-line label support
 * @param {Array} categories - Array of category labels
 * @param {Object} additionalConfig - Additional xaxis configuration
 * @returns {Object} - Complete xaxis configuration
 */
export const createMultilineXAxis = (categories, additionalConfig = {}) => {
  return {
    categories,
    labels: {
      maxHeight: 80,
      formatter: function(value) {
        return formatMultilineLabel(value);
      },
      ...additionalConfig.labels
    },
    ...additionalConfig
  };
};